import { httpClient } from '../http/httpClient'
import { GetFunnelParams, GetFunnelResponse } from './types'

export async function getFunnel(params: GetFunnelParams) {
  const { data } = await httpClient
    .get<GetFunnelResponse>('/journeys/funnel', { params })
    .catch((error) => {
      throw error?.response?.data || error
    })

  return data
}
